import { render, staticRenderFns } from "./subset-search.vue?vue&type=template&id=4cb85492&scoped=true"
import script from "./subset-search.vue?vue&type=script&lang=js"
export * from "./subset-search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb85492",
  null
  
)

export default component.exports